<div class='block-ui-template'>
    <div *ngIf='spinner' class='spinner'>
        <div class='dot1'></div>
        <div class='dot2'></div>
    </div>
    <div *ngIf='message' class='message'>{{message}}</div>
</div>
